/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/share_android'
export default icon
